import React from 'react';
import { Flex, Progress, Tooltip } from 'antd';

import THEME from '../../../../constants/theme';
import { JobChartContainer, Percent } from './JobChart.style';

interface ProgressBarProps {
  label: string;
  percentage: number;
  number: string | number;
  color: string;
}

const ProgressBar = ({ label, percentage, number, color }: ProgressBarProps) => {
  return (
    <Flex
      vertical={false}
      align="center"
      justify="space-between"
      gap={24}
      style={{ alignItems: 'center' }}
    >
      <Flex justify={'space-between'} gap={6} style={{ minWidth: 150 }}>
        <div>{label}</div>
        <div>{number}</div>
      </Flex>
      <Tooltip title={`${label} ${percentage}%`}>
        <Progress
          percent={!isNaN(percentage) ? percentage : 0}
          strokeColor={color}
          trailColor={'gray'}
          showInfo={false}
        />
      </Tooltip>
      <Percent>{!isNaN(percentage) ? percentage : 0}%</Percent>
    </Flex>
  );
};

interface JobChartProps {
  annotationSet: any;
}

const JobChart = ({ annotationSet }: JobChartProps) => {
  const totalDicoms = annotationSet?.totalNumberOfDicomLabelingJobs;
  const totalStudies = annotationSet?.totalNumberOfStudyLabelingJobs;
  const finishedDicoms = annotationSet?.numberOfFinishedDicomLabelingJobs;
  const finishedStudies = annotationSet?.numberOfFinishedStudyLabelingJobs;

  const dicomPercent = Number(((finishedDicoms / totalDicoms) * 100).toFixed(0));
  const studyPercent = Number(((finishedStudies / totalStudies) * 100).toFixed(0));

  const labeledBackgroundColor =
    annotationSet?.type === 'KEYPOINTS' ? THEME.keypoints : THEME.segmentations;
  const skippedBackgroundColor = THEME.identifier;

  return (
    <JobChartContainer>
      <div>
        <ProgressBar
          label={'Dicoms'}
          percentage={dicomPercent}
          color={labeledBackgroundColor}
          number={`${finishedDicoms}/${totalDicoms}`}
        />
        <ProgressBar
          label={'Studies'}
          percentage={studyPercent}
          color={skippedBackgroundColor}
          number={`${finishedStudies}/${totalStudies}`}
        />
      </div>
    </JobChartContainer>
  );
};

export default JobChart;
